(function () {
    'use strict';

    angular
        .module('cog.shared.customer')
        .controller('ApiPendingController', ApiPendingController);

    /* @ngInject */
    //function ApiPendingController(notificationService, accountService:IAccountService, $filter, $scope) {
    function ApiPendingController($scope, CogApiServiceProvider: ICogApiServiceProvider, PendingWagerTransformer: IPendingWagerTransformer, notificationService: INotificationService, accountService, $state, $window, appSettings, $mdMedia) {
        var vm = this;
        vm.Pages = 0;
        vm.loader = true;
        vm.isBM = CogApiServiceProvider.is_BM();
        vm.accountData = null;
        //vm.saveSettings = saveSettings;
        vm.data = null;
        vm.Templates = [{ id: 0, name: 'By Scheduled' }, { id: 1, name: 'By Placed' }];
        vm.isLand = false;
        vm.reload = reload;
        vm.currency = appSettings.currency;
        vm.currencyDecimals = appSettings.currencyDecimals;

        $scope.RRLoadComplete = (id, w) => {
            return CogWagerUtils.RRLoadComplete(id, w, $scope);
        }
        $scope.RRToggleExpand = (wager) => {
            CogWagerUtils.RRToggleExpand(wager,$scope);
        }

        activate();

        function activate() {
            vm.loader = true;
            vm.isLand = getOrientation();
            CogApiServiceProvider.apiAccService().getPending(1)
            .success(function (response: any) {
                //vm.data = response;
                vm.data = PendingWagerTransformer.transformList(response);
                vm.Pages = Math.ceil(response.TotalItemCount / response.PageSize);
                /*if (!vm.isBM)
                    getAccountSettings();*/
            })
            .error(function (error) {
            })
            .finally(function () {
                vm.loader = false;
            });
        }

        notificationService.subscribe_MSG_BM_RELOAD_PENDING($scope, function () {
            activate();
        });

        function reload() {
            $state.go($state.current, {}, { reload: true });
        }

        function getOrientation() {
            return $window.orientation == 0 || $window.orientation == 180 || $window.orientation == undefined ? false : true;
        }

        angular.element($window).bind('orientationchange', function () {
            vm.isLand = getOrientation();
        });
        /*
        function getAccountSettings() {
            accountService.getAccountSettings()
                .success(function (response) {
                    vm.accountData = response;
                    if (vm.accountData.Options.OldPendingReport)
                        vm.accountData.Options.OldPendingReport = 1;
                    else
                        vm.accountData.Options.OldPendingReport = 0;
                    if (vm.accountData.Options.TimeZone == 5)
                        vm.accountData.Options.TimeZone = 6;
                    accountService.setPendingTemplate(vm.accountData.Options.OldPendingReport);
                    vm.loader = false;
                })
                .error(function (error) {
                    vm.loader = false;
                });
        }

        function saveSettings() {
            vm.loader = true;
            accountService.saveAccountSettings(vm.accountData.Options)
                .then(function (response) {
                    vm.accountData = response;
                    if (vm.accountData.Options.OldPendingReport)
                        vm.accountData.Options.OldPendingReport = 1;
                    else
                        vm.accountData.Options.OldPendingReport = 0;
                    if (vm.accountData.Options.TimeZone == 5)
                        vm.accountData.Options.TimeZone = 6;
                    accountService.setPendingTemplate(vm.accountData.Options.OldPendingReport);
                    vm.loader = false;
                    var strPending = "cog.default.customer-pendingcat";
                    if (accountService.getPendingTemplate())
                        strPending = "cog.default.customer-pending";
                    $state.go(strPending);
                },
                function () {
                    getAccountSettings();
                });
        }*/
    }
})();
